import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class CardFilterEntity {
  includeExpired?: boolean
  region?: RegionMiniEntity
  isEnabled?: boolean
  page?: number
  limit?: number
  channel?: ChannelMiniEntity
}
